<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >


        <el-form-item
                label="标题"
                prop="title"
        >
          <el-input
                  v-model="searchForm.title"
                  placeholder="标题"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="商家名称"
                prop="agentname"
        >
          <el-input
                  v-model="searchForm.agentname"
                  placeholder="商家名称"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
        <el-select
                class="filter-item"
                v-model="searchForm.sh_state"
                placeholder="审核是否通过"
                width="50"
        >
          <el-option
                  v-for="item in settleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
              label="商家名称"
      >
        <template slot-scope="scope">
          {{scope.row.agent_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="标题"
      >
        <template slot-scope="scope">
          {{scope.row.title}}
        </template>
      </el-table-column>
      <el-table-column
        label="纬度"
      >
        <template slot-scope="scope">
          {{scope.row.latitude}}
        </template>
      </el-table-column>
      <el-table-column
              label="经度"
      >
        <template slot-scope="scope">
          {{scope.row.longitude}}
        </template>
      </el-table-column>
      <el-table-column
              label="图片/视频"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.url!=null && scope.row.url!=''">

             <span v-for="(item,index) in scope.row.url.split(',')">
                <span v-if="index==0">
              <img :src= "getImgUrl2(scope.row)" style="width: 200px;height: 100px; "/>
                   </span>
          </span>




          </div>
          <div v-if="scope.row.video_url!=null && scope.row.video_url!=''">

             <span v-for="(item,index) in scope.row.video_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl22(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              </span>
          </span>




          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="描述"
      >
        <template slot-scope="scope">
          {{scope.row.describe}}
        </template>
      </el-table-column>


      <el-table-column
              label="添加时间"
      >
        <template slot-scope="scope">
          {{scope.row.insert_times}}
        </template>
      </el-table-column>

      <el-table-column
              label="是否上架"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0' ">
           上架
          </div>
          <div v-else-if="scope.row.state=='1'">
            下架
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="是否关联商品"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type=='0' ">
           图片
          </div>
          <div v-else-if="scope.row.type=='1'">
            视频
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="发送类型"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.send_type=='0' ">
            全部
          </div>
          <div v-else-if="scope.row.send_type=='1'">
            部分
          </div>

        </template>
      </el-table-column>

      <el-table-column
              label="发送状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.send_state=='0' ">
            未发送
          </div>
          <div v-else-if="scope.row.send_state=='1'">
            待发送
          </div>
          <div v-else-if="scope.row.send_state=='2'">
            已发送
          </div>
          <div v-else-if="scope.row.send_state=='3'">
            发送中
          </div>
        </template>
      </el-table-column>






      <el-table-column
              label="审核状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.sh_state=='0'">
            未审核
          </div>
          <div v-else-if="scope.row.sh_state=='1'">
            审核通过
          </div>
          <div v-else-if="scope.row.sh_state=='2'">
            审核不通过
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="审核备注"
      >
        <template slot-scope="scope">
          {{scope.row.sh_description}}
        </template>
      </el-table-column>


      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">

          <el-button
                  type="primary"
                  plain
                  size="mini"
                  v-if="scope.row.sh_state=='0'"
                  @click="openEditForm(scope.row)"
          >审核</el-button>

            <el-button
                    type="primary"
                    plain
                    size="mini"
                    @click="openViewForm(scope.row)"
            >详情</el-button>




        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />
    <view-form
            :oneclass="oneclass"
            v-model="viewFormVisible"
            @submit="getTableData"
    />


  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import viewForm from "./viewForm";
import util from '@/libs/util.js'
export default {
  name: "SmallposterPage",
  components: { editForm,viewForm },
  data() {
    const end = new Date();
    const start = new Date();
    return {
      searchForm: {
      },
      loading: false,
      tableData: [],
      dateRange: [],
      multipleSelection: [],
      pickerOptions:{},
      is_agentid:util.cookies.get('agentid'),
      is_dl_type:util.cookies.get('dl_type'),
      is_sys_kf:util.cookies.get('is_sys_kf'),
      settleOptions: [
        {
          value: "0",
          label: "未审核"
        },
        {
          value: "1",
          label: "审核通过"
        },

        {
          value: "2",
          label: "审核未通过"
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      viewFormVisible: false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        start_time:this.dateConversion(this.dateRange[0]),
        end_time:this.dateConversion(this.dateRange[1]),
          agentid: util.cookies.get('agentid'),
          xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.messagePagedlist(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    dateConversion(value) {
      if (value != null && value != "") {
        var d = new Date(value);
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        console.info("===========date=========" + date);
        return date;
      }else{
        return "";
      }
    },
    getImgUrl2(row){
      var good_url=row.url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
    },
    getImgUrl22(row){
      var good_url=row.video_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
      this.viewFormVisible = false;
    },
    openViewForm(oneclass) {
      this.oneclass = oneclass;
      this.viewFormVisible = true;
      this.editFormVisible = false;
    },


    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    }
  }
};
</script>
